import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ProcorManutencaoComunicadoComponent } from '../procor-manutencao-comunicado.component';
import { ProcorManutencaoComunicadoIncluirAlterarComponent } from '../procor-manutencao-comunicado-incluir-alterar/procor-manutencao-comunicado-incluir-alterar.component';


const procorRoutes = [
    { path: 'procor', component: ProcorManutencaoComunicadoComponent },
    { path: 'procor/incluir', component: ProcorManutencaoComunicadoIncluirAlterarComponent },
    { path: 'procor/alterar', component: ProcorManutencaoComunicadoIncluirAlterarComponent },

];

@NgModule({
    imports: [RouterModule.forChild(procorRoutes)],
    exports: [RouterModule]
})
export class ProcorManutencaoComunicadoRouterngModule {


}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/administrativo/procor-manutencao-comunicado/router/procor-manutencao-comunicado.router.ts